import { Directive, afterNextRender } from '@angular/core';

declare global {
  interface Window {
    tf?: { load(): void; reload(): void };
  }
}

/**
 * Tells the Typeform embed SDK to re-scan the DOM for new `data-tf-*` elements.
 *
 * The SDK (`embed.typeform.com/next/embed.js`) scans once on initial page load.
 * Elements rendered later by Angular's conditional templates (`@if`, `ngIf`)
 * are missed. Applying this directive to a Typeform container triggers
 * `window.tf.load()` after Angular commits the element to the DOM.
 */
@Directive({
  selector: '[appTypeformLoad]',
})
export class TypeformLoadDirective {
  constructor() {
    afterNextRender(() => {
      window.tf?.load();
    });
  }
}
